export default __webpack_public_path__ + "static/media/finane.1e429c9d.svg";